import request from '@/utils/request'

export function getTotalIncome(params) {
  return request({
    url: 'agent_admin/report/total_income',
    method: 'get',
    params
  })
}

export function getHostessIncome(params) {
  return request({
    url: 'agent_admin/host/report',
    method: 'get',
    params
  })
}

export function getData(data) {
  return request({
    url: '/agent_admin/report/hotchat/host',
    method: 'post',
    data
  })
}

export function getSettlementData(data) {
  return request({
    url: 'agent_admin/report/hotchat/settle/host',
    method: 'post',
    data
  })
}

export function downloadDetail(data, type) {
  const url =
    type == 1
      ? 'agent_admin/report/hotchat/download/host'
      : type == 2
      ? 'agent_admin/report/hotchat/download/host'
      : 'agent_admin/report/hotchat/download/settle/host'
  return request({
    url,
    method: 'post',
    data,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    },
    responseType: 'blob'
  })
}
